import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e54bb1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BusinessOpportunity" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "相关求购", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "相关处理", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的求购", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的报价", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanTab = _resolveComponent("VanTab")!
  const _component_VanTabs = _resolveComponent("VanTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanTabs, {
      class: "tabs",
      active: $setup.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
      animated: "",
      "title-active-color": "#FEC64B",
      "title-inactive-color": "#333333"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanTab, { name: "relatedPurchase" }, {
          title: _withCtx((props) => [
            _createVNode(_component_VanImage, {
              src: $setup.active=="relatedPurchase"?require("@/assets/img/businessOpportunity/shangji_qiugou_act.png"):require("@/assets/img/businessOpportunity/shangji_qiugou.png"),
              width: "40",
              height: "40"
            }, null, 8, ["src"]),
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode($setup["RelatedPurchaseList"], { active: $setup.active }, null, 8, ["active"])
          ]),
          _: 1
        }),
        _createVNode(_component_VanTab, { name: "relatedProcessing" }, {
          title: _withCtx((props) => [
            _createVNode(_component_VanImage, {
              src: $setup.active=="relatedProcessing"?require("@/assets/img/businessOpportunity/message_5_act.png"):require("@/assets/img/businessOpportunity/message_5.png"),
              width: "40",
              height: "40"
            }, null, 8, ["src"]),
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode($setup["RelatedProcessing"], { active: $setup.active }, null, 8, ["active"])
          ]),
          _: 1
        }),
        _createVNode(_component_VanTab, { name: "myPurchase" }, {
          title: _withCtx((props) => [
            _createVNode(_component_VanImage, {
              src: $setup.active=="myPurchase"?require("@/assets/img/businessOpportunity/message_1_act.png"):require("@/assets/img/businessOpportunity/message_1.png"),
              width: "40",
              height: "40"
            }, null, 8, ["src"]),
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode($setup["MyPurchase"], { active: $setup.active }, null, 8, ["active"])
          ]),
          _: 1
        }),
        _createVNode(_component_VanTab, { name: "myQuote" }, {
          title: _withCtx((props) => [
            _createVNode(_component_VanImage, {
              src: $setup.active=="myQuote"?require("@/assets/img/businessOpportunity/message_2_act.png"):require("@/assets/img/businessOpportunity/message_2.png"),
              width: "40",
              height: "40"
            }, null, 8, ["src"]),
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode($setup["MyQuoteList"], { active: $setup.active }, null, 8, ["active"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}